import {
  SET_USIS_DATA,
  SET_USIS_MODAL_STEP,
  TOGGLE_USIS_MODAL_OPEN,
  WAITING_REQUEST,
  CLOSE_USIS_CONFIRM_DEACTIVATE_MODAL,
  OPEN_USIS_CONFIRM_DEACTIVATE_MODAL,
  SET_IS_FETCH_ERROR,
  SET_MODAL_VARIANT, TOGGLE_USIS_COMMON_MODAL_OPEN,
  SET_USIS_COMMON_MODAL_STEP, ADD_NOTIFICATION_PD, REMOVE_NOTIFICATION_PD, SET_IS_ONLY_ONCE_VARIANT_UPD,
} from './actions';

const initialState = {
  isModalOpened: false,
  isCommonModalOpened: false,
  isModalConfirmDeactivateOpened: false,
  usisModalStep: '',
  usisCommonModalStep: '',
  isFetchError: false,
  modalVariant: '',
  hasQueryInUrl: false,
  notifications: [],
};

export default function (state = initialState, action) {
  switch (action.type) {
    case SET_USIS_DATA:
      return {
        ...state,
        usisData: {
          ...state.usisData, ...action.payload,
        },
      };

    case TOGGLE_USIS_MODAL_OPEN:
      return {
        ...state,
        isModalOpened: action.payload,
      };

    case TOGGLE_USIS_COMMON_MODAL_OPEN:
      return {
        ...state,
        isCommonModalOpened: action.payload,
      };

    case SET_USIS_MODAL_STEP:
      return {
        ...state,
        usisModalStep: action.payload,
      };

    case SET_USIS_COMMON_MODAL_STEP:
      return {
        ...state,
        usisCommonModalStep: action.payload,
      };
    case WAITING_REQUEST:
      return {
        ...state,
        isWaitingRequest: action.payload,
      };
    case CLOSE_USIS_CONFIRM_DEACTIVATE_MODAL:
      return {
        ...state,
        isModalConfirmDeactivateOpened: false,
      };
    case OPEN_USIS_CONFIRM_DEACTIVATE_MODAL:
      return {
        ...state,
        isModalConfirmDeactivateOpened: true,
      };
    case SET_IS_FETCH_ERROR:
      return {
        ...state,
        isFetchError: action.payload,
      };
    case SET_MODAL_VARIANT:
      return {
        ...state,
        modalVariant: action.payload,
      };

    case ADD_NOTIFICATION_PD:
      return {
        ...state,
        notifications: state.notifications.concat(action.payload),
      };

    case REMOVE_NOTIFICATION_PD:
      const filteredNotifications = state.notifications.filter((item) => item.id !== action.payload);

      return {
        ...state,
        notifications: filteredNotifications,
      };

    case SET_IS_ONLY_ONCE_VARIANT_UPD:
      return {
        ...state,
        isOnlyOnceVariantUpd: action.payload,
      };
    default:
      return state;
  }
}
